var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"box-scroll"},[_vm._l((10),function(item,index){return _c('div',{key:index},[_vm._v(_vm._s(index + 1))])}),_c('div',{staticClass:"box-scroll-sticky"},[_vm._v("我要悬浮在40px处")]),_vm._l((100),function(item,index){return _c('div',{key:index},[_vm._v(_vm._s(index + 1))])})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }